module.exports = __webpack_public_path__ + "static/media/bg_price_plan_under_30.ce6ecde2.webp";